import { DataTable } from "@/components/common/DataTable";
import StaffingModal from "./StaffingModal";
import { useApiClient } from "@/context/ApiContext";
import { getApplicantsWithFilters } from "@/services/applicant/Applicant";
import { getUsersWithFilters } from "@/services/user/User";
import { getProcessesForPosting } from "@/services/staffing/Staffing";
import { Applicant } from "@/types/common/applicant";
import { StaffMember } from "@/types/common/staffMember";
import { Process, ProcessRow } from "@/types/staffing/process";
import { ODataParams } from "@/utils/odataUtil";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getProcessModalColumns } from "../columns/StaffingDashboardColumns";
interface InProcessStaffingProps {
    processes: Process[];
    open: boolean;
    onOpenChange: (open: boolean) => void;
    clientId: number | null;
    clientName: string | null;
    postingId: number | null;
}



const InProcessStaffing = ({ processes, open, onOpenChange, clientId, clientName, postingId }: InProcessStaffingProps) => {
    const [rows, setRows] = useState<ProcessRow[]>(processes);
    const [processList, setProcessList] = useState<Process[]>(processes);
    const apiClient = useApiClient();
    const processModalColumns = useMemo(() => getProcessModalColumns(clientId ?? 0), [clientId]);
    const getStaffPromise = useCallback((staff: ProcessRow): Promise<ProcessRow> => {
        const login : string = staff.Staff.split('\\')[1];
        const filters: ODataParams = {
            filter: `LoginName eq '${login}'`
        };
        return getUsersWithFilters(filters, apiClient)
            .then((res) => {
                const user: StaffMember = res.data.value[0];
                return user ? { ...staff, City: user.City, FullName: user.FullName, StaffId: user.Id, Role: user.Role } : staff;
            })
            .catch(err => {
                console.error(err);
                return staff;
            });
    }, [apiClient]);
    const getApplicantPromise = useCallback((applicant: ProcessRow): Promise<ProcessRow> => {
        const filters: ODataParams = {
            filter: `Email eq '${applicant.Staff}'`
        };
        return getApplicantsWithFilters(filters, apiClient)
            .then((res) => {
                const user: Applicant = res.data.value[0];
                return user ? { ...applicant, City: user.City, FullName: user.FullName, StaffId: user.Id, Role: user.Role } : applicant;
            })
            .catch(err => {
                console.error(err);
                return applicant;
            });
    }, [apiClient]);
    useEffect(() => {
        setProcessList(processes);
    }, [processes])
    useEffect(() => {
        if (!open || postingId == null) return;
        getProcessesForPosting(postingId, apiClient)
            .then((res) => {
                const posting = res.data.value?.[0];
                if (posting?.Processes) setProcessList(posting.Processes);
            })
            .catch(err => console.error(err))
    }, [open, postingId, apiClient])
    useEffect(() => {
        const staff: ProcessRow[] = processList.filter((x) => !x.Applicant)
        const applicants: ProcessRow[] = processList.filter((x) => x.Applicant)
        let promises: Promise<ProcessRow>[] = [];
        staff.forEach((row) => {
            promises.push(getStaffPromise(row));
        })
        applicants.forEach((row) => {
            promises.push(getApplicantPromise(row));
        })
        Promise.all(promises)
            .then((res) => {
                setRows(res);
            })
    }, [processList, getStaffPromise, getApplicantPromise])
    return (
        <StaffingModal open={open} onOpenChange={onOpenChange} title={"Staffing in Process" + (clientName ? ' - ' + clientName : '')} wide>
            <DataTable data={rows} columns={processModalColumns} />
        </StaffingModal>
    );
};

export default InProcessStaffing;
